import React, {useState, useEffect} from 'react';
import StreetView from "react-google-streetview";
import PropTypes from "prop-types";

function StreetViewMap(props) {

    const [showMap, setShowMap] = useState(false);
    const [latitude, setLatitude] = useState(0);
    const [longitude, setLongitude] = useState(0);
    const [heading, setHeading] = useState(0);
    const [panoId, setPanoId] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setLatitude(props.latitude);
            setLongitude(props.longitude);
            setHeading(props.heading);
            setPanoId(props.panoId);
            if (props.panoId !== '' && props.panoId !== null && props.panoId !== undefined) {
                setShowMap(true);
            }
            console.log('show')
        }, 500);
        return () => {
            clearTimeout(timer);
        }
    }, [props]);

    const GoogleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
    let StreetMapOptions = {
        // position: {lat: latitude, lng: longitude},
        pov: {heading: heading, pitch: 15},
        pano: panoId,
        streetViewPanoramaOptions: {
            fullscreenControl: false
        }
    };

    return (
        <div>
            <div
                style={{
                    width: "100%",
                    height: "240px",
                    backgroundColor: "#cccccc",
                }}
            >
                {showMap && (
                    <StreetView
                        apiKey={GoogleMapApiKey}
                        streetViewPanoramaOptions={StreetMapOptions}
                    />
                )}
            </div>
        </div>
    );
}

StreetViewMap.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    heading: PropTypes.number,
    panoId: PropTypes.string,
}
export default StreetViewMap;